import { render } from "./post-smtp-cards-container.vue?vue&type=template&id=2dc01e40&scoped=true"
import script from "./post-smtp-cards-container.vue?vue&type=script&lang=js"
export * from "./post-smtp-cards-container.vue?vue&type=script&lang=js"

import "./post-smtp-cards-container.vue?vue&type=style&index=0&id=2dc01e40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc01e40"]])

export default __exports__